import Vue from 'vue';

/**
 * 格式化时间戳
 * @param timestamp
 * @returns {string}
 */
Vue.prototype.formatDate = (timestamp) => {
  const year = timestamp.getFullYear();

  const month = timestamp.getMonth() + 1;

  const date = timestamp.getDate();

  const hour = timestamp.getHours();

  const minute = timestamp.getMinutes();

  const second = timestamp.getSeconds();

  return year + "-" + month + "-" + date + "   " + hour + ":" + minute + ":" + second;
};

/**
 * 公共bodyParams参数
 * @param obj
 * @param pager
 * @return {*}
 */
Vue.prototype.commonBodyParams = (obj, pager) => {
  if (pager && pager !== undefined) {
    return Object.assign({}, {
      pageIndex: pager.pageIndex,
      pageSize: pager.pageSize
    }, obj);
  }
};
